<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout column fill-height class="more-page">
    <v-flex class="shrink">
      <!-- 테스크탑 바 -->
      <DesktopBar/>
    </v-flex>
    <v-flex class="grow" style="background-color: #fafafa;">
      <v-container fill-height :style="'max-width:' + $vuetify.breakpoint.thresholds.md + 'px'">
        <v-layout column>
          <v-flex class="shrink text-xs-left profile-area">
            <div v-if="!auth.isAuth">
              <h2>
                <strong @click="auth.modal.login = true">
                  <span class="py-4">로그인 <v-icon size="30" class="pa-0" color="#111">keyboard_arrow_right</v-icon></span>
                </strong>
              </h2>
              <span class="grey--text">간편하게 로그인하여 이용하세요.</span>
            </div>
            <v-layout v-if="auth.isAuth" class="align-center">
              <v-flex shrink>
                <v-avatar size="40">
                  <img
                    :src="auth.profile_img"
                    :alt="auth.name"
                  >
                </v-avatar>
              </v-flex>
              <v-flex shrink class="ml-3">
                <span class="name">{{auth.name}}님</span><br>
                <span class="id">{{auth.id}}</span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <a href="/rep/pro" target="_blank" class="bt" v-if="auth.isStaff">관리자</a><span class="bt"  @click="$utile.move($utile.getBaseUrl() + '/bbs/member_confirm?url=' + $utile.getBaseUrl() + '/bbs/register_form')">내정보</span><span class="bt" @click="logout">로그아웃</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-divider class="my-3"></v-divider>
          <v-flex class="grow">
            <div class="text-xs-center mt-2 mb-4 call_center">
              <div>
                <v-icon size="38" class="icon">phone</v-icon>
              </div>
              <div class="item-info">
                <span class="headline"><strong><a :href="'tel:' + config.company.customerNumber" class="text-point">{{config.company.customerNumber}}</a></strong></span><br>
                {{config.company.customerTime}}
              </div>
            </div>
            <div class="contents-box">
              <v-layout row wrap align-start justify-space-around>
                <v-flex class="item-box shrink text-xs-center" @click="findRoom()">
                  <div>
                    <v-icon class="icon">home</v-icon>
                  </div>
                  <div class="item-name">
                    방찾아주세요
                  </div>
                </v-flex>
                <!--
                <v-flex class="item-box shrink text-xs-center" @click="showItemReceipt()">
                  <div>
                    <v-icon class="icon">home</v-icon>
                  </div>
                  <div class="item-name">
                    방내놔요
                  </div>
                </v-flex>
                -->
                <v-flex class="item-box shrink text-xs-center" @click="kakaoChat()">
                  <div>
                    <v-icon class="icon">question_answer</v-icon>
                  </div>
                  <div class="item-name">
                    1:1 채팅상담
                  </div>
                </v-flex>
                <v-flex class="item-box shrink text-xs-center" @click="contentType = 'faq'">
                  <div>
                    <v-icon class="icon">insert_comment</v-icon>
                  </div>
                  <div class="item-name">
                    자주하는질문
                  </div>
                </v-flex>
                <v-flex class="item-box shrink text-xs-center" @click="contentType = 'notice'">
                  <div>
                    <v-icon class="icon">notification_important</v-icon>
                  </div>
                  <div class="item-name">
                    공지사항
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <!-- 맵 -->
            <div class="contents-box mt-3" v-if="contentType === 'map'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">오시는길</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <div class="mini-map">
                    <div class="info-box elevation-5">
                      <span class="font-weight-medium" style="font-size: 14px;">{{config.company.name}}</span><br>
                      <span class="font-weight-light" style="font-size: 12px;" v-html="config.company.addr"></span>
                    </div>
                    <mini-map ref="minimap3"
                              :appKey="map.appKey"

                              :center="map.center"
                              :level="map.level"
                              :mapTypeId.sync="map.mapTypeId"
                              :libraries="map.libraries"

                              @load="onLoad"
                              @zoom_start="onMapEvent('zoom_start', $event)"
                              @zoom_changed="onMapEvent('zoom_changed', $event)"
                              @click="onMapEvent('click', $event)"
                              @dblclick="onMapEvent('dblclick', $event)"
                              @rightclick="onMapEvent('rightclick', $event)"
                              @dragstart="onMapEvent('dragstart', $event)"
                              @dragend="onMapEvent('dragend', $event)"
                              @idle="onMapEvent('idle', $event)"
                              @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                              style="position:relative; height: 100%;">
                    </mini-map>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <!-- 자주하는질문 -->
            <div class="contents-box mt-3" v-if="contentType === 'faq'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">자주하는질문</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content
                      v-for="(item,i) in faq_data"
                      :key="i"
                    >
                      <template v-slot:actions>
                        <v-icon color="primary">$vuetify.icons.expand</v-icon>
                      </template>
                      <template v-slot:header>
                        <div>
                          <v-avatar color="title_dark1" size="28" class="mr-2">
                            <span class="white--text body-1">Q</span>
                          </v-avatar>
                          <span>{{item.subject}}</span>
                        </div>
                      </template>
                      <v-card>
                        <v-card-text class="grey lighten-3 pa-5">
                          <v-avatar color="red" size="28" class="mr-2">
                            <span class="white--text body-1">A</span>
                          </v-avatar>
                          <span v-html="item.contents"></span>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </div>
            <!-- 공지사항 -->
            <div class="contents-box mt-3" v-if="contentType === 'notice'">
              <v-layout class="column wrap">
                <v-flex class="shrink text-xs-left">
                  <h2>
                    <strong>
                      <span class="py-4">공지사항</span>
                    </strong>
                  </h2>
                </v-flex>
                <v-divider class="my-3"></v-divider>
                <v-flex>
                  <v-expansion-panel>
                    <v-expansion-panel-content
                      v-for="(item,i) in notice_data"
                      :key="i"
                    >
                      <template v-slot:header>
                        <div>
                          <v-avatar color="#bbb" size="28" class="mr-2">
                            <span class="white--text body-1">!</span>
                          </v-avatar>
                          <span>{{item.subject}}</span>
                        </div>
                      </template>
                      <v-card>
                        <v-card-text class="grey lighten-3 pa-5" v-html="item.contents"></v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex class="shrink">
      <!-- 하단내용 -->
      <Footer/>
    </v-flex>
  </v-layout>
</template>

<script>
import Footer from './layout/Footer'

import EventBus from '@/utile/eventBus'
import MiniMap from '@/components/plugin/KakaoMap'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'More',
  data: () => ({
    contentType: 'map',
    // 맵
    map: {
      appKey: '',
      center: { lat: 37.4803073, lng: 126.9328443 },
      level: 4, // 기본 3
      mapTypeId: MiniMap.MapTypeId.NORMAL,
      libraries: [ 'services' ],
      mapObject: null,
      geocoder: null,
      roadviewArea: false,
      polygon: null
    },
    notice_data: [],
    faq_data: []
  }),
  created () {
    this.map.appKey = this.config.kakaRestApiAppKey
  },
  mounted () { // 시작
    // 지도 로드
    this.$refs.minimap3.init()
    // 게시판 로드
    this.faqListUpdate()
    this.noticeListUpdate()
  },
  methods: { // 메소드
    ...mapActions({
      requestBoardData: 'board/requestBoardData',
      requestAuthData: 'auth/requestAuthData'
    }),
    kakaoChat () {
      window.open('https://pf.kakao.com/_WcBHj/chat', '_blank')
    },
    /* 맵 온로드 */
    onLoad (map) {
      this.map.mapObject = map
      this.$refs.minimap3.addressSearch(this.config.company.addr)
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      //
    },
    faqListUpdate () {
      this.requestBoardData({ 'type': 'faqList' }).then((data) => {
        if (data.array.length > 0) {
          const _this = this
          data.array.forEach(function (value) {
            _this.faq_data.push(value)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    noticeListUpdate () {
      this.requestBoardData({ 'type': 'noticeList' }).then((data) => {
        if (data.array.length > 0) {
          const _this = this
          data.array.forEach(function (value) {
            _this.notice_data.push(value)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    showItemReceipt () {
      if (this.auth.isAuth) {
        this.board.itemReceipt.show = true
      } else {
        EventBus.$emit('alert', '로그인 후 이용가능합니다.')
        this.auth.modal.login = true
      }
    },
    logout () {
      this.requestAuthData({'type': 'logout'}).then((data) => {
        // 로그아웃
        // console.log('!!!!!!!!!!!!!!1 logout')
      })
    },
    findRoom: () => {
      EventBus.$emit('findRoom', 0)
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    })
  },
  components: {
    Footer,
    MiniMap
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/More.vue